import { phoneDesc, isPhoneNumber, EncryptName } from "../../util/index";
import { useMainStore } from "../../pinia/main";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive } from "vue";
import moment from "moment";
import { invoiceSuccessList } from "@/util/type";
export default {
  name: "StatementAccountDetail",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const mainStore = useMainStore();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      info: {}
    });
    onMounted(() => {
      selectForwarderStatementInfo();
    });
    const selectForwarderStatementInfo = async () => {
      data.info = await globalProperties.$api.selectForwarderStatementInfo(route.query.orderId);
    };
    return {
      mainStore,
      data,
      moment,
      phoneDesc,
      isPhoneNumber,
      EncryptName,
      invoiceSuccessList
    };
  }
};